import { API_ROOT } from 'signoxe/constants/config'
import { getAuthTokenHeader } from 'signoxe/actions/remote';

const DEFAULT_CHUNK_SIZE = 2 // Measured in MB
const ENDPOINT = 'media/upload'


export default function getOptions(token, file) {
  return {
    endpoint: `${API_ROOT}${ENDPOINT}/start`,
    chunkSize: 1024 * 1024 * DEFAULT_CHUNK_SIZE,
    headers: {
      "Authorization": getAuthTokenHeader()
    },
    retryDelays: [0, 1000, 3000, 5000],
    parallelUploads: 1,
    metadata: {
      filename: file.name,
      filetype: file.type
    },
    removeFingerprintOnSuccess: true,
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/utils/tusOptions.js